import mixpanel from 'mixpanel-browser'

export abstract class BaseMixpanelTracker {
  constructor(
    private readonly projectToken: string,
    private config?: Parameters<typeof mixpanel.init>[1],
  ) {}

  initialize() {
    mixpanel.init(this.projectToken, this.config)
  }

  // abstract identify(uniqueId: string, ...rest): void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract behaviorTrack(eventName: string, eventProps?: Record<string, any>): void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract uiTrack(eventName: string, eventProps?: Record<string, any>): void

  abstract apiTrack(response: unknown): void
  abstract errorTrack(response: unknown): void

  abstract strapiTrack(response: unknown): void
  abstract strapiErrorTrack(response: unknown): void

  abstract printApiTrack(response: unknown): void
  abstract printErrorTrack(response: unknown): void
}
